/* eslint-disable
    func-names,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
const deps = ['$injector', '$parse'];
const factory = function ($injector, $parse) {
  const Relation = function (modelType, idName, defaultData = {}) {
    let Model = {};

    const injectModel = _Model_ => (Model = _Model_);

    injectModel.$inject = [modelType];

    return function (data = defaultData) {
      let id;
      $injector.invoke(injectModel);
      if (typeof idName === 'function') {
        id = idName.bind(this)();
      } else {
        id = $parse(idName)(this);
      }
      return new Model((typeof id === 'function' ? id() : undefined) || id, data);
    };
  };

  return Relation;
};

factory.$inject = deps;

module.exports = factory;
